import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/AIHeuristicCard/card/classes2.png';
import _imports_1 from '@/assets/images/AIHeuristicCard/card/classes1.png';
import _imports_2 from '@/assets/images/AIHeuristicCard/card/classes3.png';
const _withScopeId = n => (_pushScopeId("data-v-fee2b018"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ai-design-center"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = {
  class: "bottom"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"img-list\" data-v-fee2b018><img src=\"" + _imports_0 + "\" alt=\"\" data-v-fee2b018><div class=\"img-bottom\" data-v-fee2b018><img src=\"" + _imports_1 + "\" alt=\"\" data-v-fee2b018><img src=\"" + _imports_2 + "\" alt=\"\" data-v-fee2b018></div></div>", 1);
import i18n from '@/language/index';
export default {
  __name: 'CenterContent',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
        class: _normalizeClass(["common-text common-title", _unref(i18n).global.locale.value === 'en' ? 'common-title-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.whatDesignSprint')), 3), _createElementVNode("div", {
        class: _normalizeClass(["desc common-text common-p", _unref(i18n).global.locale.value === 'en' ? 'common-p-en' : ''])
      }, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.desc1')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.desc2')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.desc3')), 1)], 2)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", {
        class: _normalizeClass(["common-text common-title", _unref(i18n).global.locale.value === 'en' ? 'common-title-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.title2')), 3), _createElementVNode("div", {
        class: _normalizeClass(["desc common-text common-p", _unref(i18n).global.locale.value === 'en' ? 'common-p-en' : ''])
      }, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.desc4')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('aiHeuristicCard.aiDesign.desc5')), 1)], 2)]), _hoisted_6])])]);
    };
  }
};